export default {
  'pc_monetization_revenue': 'Revenue({unit})',
  'pc_monetization_revenue_sum': 'Sum Revenue({unit})',
  'pc_monetization_net_revenue': 'Revenue After Refund & Tax({unit})',
  'pc_monetization_net_revenue_sum': 'Sum Revenue After Refund & Tax({unit})',
  'pc_monetization_units': 'Units',
  'pc_monetization_units_sum': 'Sum Units',
  'pc_monetization_full_units': 'Base Game Units After Refund',
  'pc_monetization_full_units_sum': 'Sum Base Game Units After Refund',
  'pc_monetization_mtx_Revenue($)': 'In-Game Revenue({unit})',
  'pc_monetization_mtx_Revenue': 'In-Game Revenue',
  'pc_monetization_mtx_ARPU_title': 'In-Game ARPU & ARPPU',
  'pc_monetization_mtx_ARPU': 'In-Game ARPU({unit})',
  'pc_monetization_mtx_ARPPU': 'In-Game ARPPU({unit})',
  'pc_monetization_revenue_Payer_And_Payer%': 'In-Game Payer and  Payer%',
  'pc_monetization_revenue_Payer': 'In-Game Payer',
  'pc_monetization_revenue_Payer%': 'In-Game Payer%',
  'pc_monetization_mtx_revenue_platform_distribution': 'In-Game Revenue Platform Distribution',
  'pc_monetization_mtx_Rev': 'In-Game Rev({unit})',
  'pc_monetization_mtx_Rev_sum': 'Sum In-Game Rev({unit})',

  'pc_monetization_mtx_arpu': 'In-Game ARPU({unit})',
  'pc_monetization_mtx_arpu_avg': 'Avg.In-Game ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_day': 'Avg.In-Game ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_week': 'Avg.In-Game ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_month': 'Avg.In-Game ARPU({unit})',

  'pc_monetization_mtx_arppu': 'In-Game ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg': 'Avg.In-Game ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_day': 'Avg.In-Game ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_week': 'Avg.In-Game ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_month': 'Avg.In-Game ARPPU({unit})',

  // dl2特殊配置
  'pc_monetization_mtx_Rev_dl2': 'MTX Revenue({unit})',
  'pc_monetization_mtx_Rev_sum_dl2': 'Sum MTX Revenue({unit})',

  'pc_monetization_MTX_Revenue_dl2': 'MTX Revenue({unit})',
  'pc_monetization_MTX_Revenue_title_dl2': 'MTX Revenue',
  'pc_monetization_MTX_ARPU_dl2': 'ARPU({unit})',
  'pc_monetization_MTX_ARPU_title_dl2': 'ARPU',
  'pc_monetization_MTX_ARPPU_dl2': 'ARPPU({unit})',
  'pc_monetization_MTX_ARPPU_title_dl2': 'ARPPU',

  'pc_monetization_mtx_arpu_dl2': 'ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_dl2': 'Avg.ARPU({unit})',

  'pc_monetization_mtx_arppu_dl2': 'ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_dl2': 'Avg.ARPPU({unit})',

  'pc_monetization_mtx_payer_dl2': 'Payer',
  'pc_monetization_mtx_payer_avg_dl2': 'Avg.Payer',

  'pc_monetization_mtx_payer_rate_dl2': 'Pay Rate',
  'pc_monetization_mtx_payer_rate_avg_dl2': 'Avg.Pay Rate',

  'pc_monetization_mtx_payer': 'In-Game Payer',
  'pc_monetization_mtx_payer_avg': 'Avg.In-Game Payer',
  'pc_monetization_mtx_payer_avg_day': 'Avg.In-Game Payer',
  'pc_monetization_mtx_payer_avg_week': 'Avg.In-Game Payer',
  'pc_monetization_mtx_payer_avg_month': 'Avg.In-Game Payer',

  'pc_monetization_mtx_payer_rate': 'In-Game Payer%',
  'pc_monetization_mtx_payer_rate_avg': 'Avg.In-Game Payer%',
  'pc_monetization_mtx_payer_rate_avg_day': 'Avg.In-Game Payer%',
  'pc_monetization_mtx_payer_rate_avg_week': 'Avg.In-Game Payer%',
  'pc_monetization_mtx_payer_rate_avg_month': 'Avg.In-Game Payer%',

  'pc_monetization_MTX_Revenue': 'In-Game Revenue({unit})',
  'pc_monetization_MTX_Revenue_title': 'In-Game Revenue',
  'pc_monetization_MTX_ARPU': 'In-Game ARPU({unit})',
  'pc_monetization_MTX_ARPU_title': 'In-Game ARPU',
  'pc_monetization_MTX_ARPPU': 'In-Game ARPPU({unit})',
  'pc_monetization_MTX_ARPPU_title': 'In-Game ARPPU',

  'pc_console_revenue_net_units_category_title': 'Base Game Units After Refund Per Product Category',
  'pc_console_revenue_net_units_product_title': 'Base Game Units After Refund Per Product',
  'pc_console_revenue_net_units': 'Units',
  'pc_console_revenue_net_revenue_category_title': 'Revenue After Refund & Tax Per Product Category',
  'pc_console_revenue_net_revenue_product_title': 'Revenue After Refund & Tax Per Product',
  'pc_console_revenue_net_revenue': 'Revenue({unit})',

  'pc_console_revenue_step': 'Step',
  'pc_console_revenue_conversion%': 'Conversion%',
  'pc_console_revenue_users': 'Users',
  'pc_console_revenue_conversion_&_counts': 'Conversion% & Counts',

  'pc_console_revenue_total_mtx_revenue': 'Lifetime In-Game Rev({unit})',
  'pc_console_revenue_total_mtx_payers': 'Lifetime In-Game Payer',
  'pc_console_revenue_total_mtx_payer_rate': 'Lifetime In-Game Payer%',
  'pc_console_revenue_mtx_revenue': 'In-Game Revenue',

  'pc_console_revenue_mtx_arpu': 'In-Game ARPU',
  'pc_console_revenue_mtx_arppu': 'In-Game ARPPU',
  'pc_console_revenue_mtx_payers': 'In-Game Payer',

  'pc_console_revenue_mtx_payer_rate': 'In-Game Payer%',
  'pc_console_revenue_new_user_mtx_payer_rate': 'In-Game Payer%(New Users)',
  'pc_console_revenue_mtx_new_paid_users': 'First-time In-Game Payer',

  'pc_console_revenue_mtx_new_pay_amount': 'Rev(First-time In-Game Payer)({unit})',
  'pc_console_revenue_mtx_new_arpu': 'First-time In-Game Payer ARPU({unit})',
  'pc_console_revenue_new_user_arpu': 'New User ARPU({unit})',
  'pc_console_revenue_total_pay_days': 'Total Pay Days',

  'pc_console_revenue_30d_ltv': 'In-Game LTV30',
  'pc_console_revenue_180d_ltv': 'In-Game LTV180',
  'pc_console_revenue_overview_overall_performance': 'Overall_Performance',

  'pc_console_revenue_breakdown_net_revenue': 'Revenue After Refund & Tax({unit})',
  'pc_console_revenue_units_net_revenue': 'Base Game Revenue After Refund & Tax({unit})',
  'pc_console_revenue_dlc_net_revenue': 'Net DLC Rev({unit})',
  'pc_console_revenue_net_units_count': 'Base Game Units After Refund',
  'pc_console_revenue_avg_net_price': 'AVG.NET Price',
  'pc_console_revenue_gross_revenue': 'Gross Revenue({unit})',
  'pc_console_revenue_gross_units_sold': 'Gross Units',
  'pc_console_revenue_gross_base_game_units': 'Gross Base Game Units',
  'pc_console_sales_overview_refund_revenue_currency': 'Refund Revenue({unit})',

  'pc_console_revenue_sales_revenue': 'Platform Sales Revenue',
  'pc_console_revenue_sales_breakdown': 'Platform Sales Breakdown',
  'pc_console_revenue_ingame_revenue': 'In-Game Revenue',
  'pc_console_revenue_ingame_breakdown': 'In-Game Breakdown',

  'pc_console_revenue_units_dlc_rev': 'Revenue After Refund & Tax({unit})',
  'pc_console_revenue_units_dlc_rev_title': 'Revenue After Refund & Tax',
  'pc_console_revenue_units_net_rev': 'Units Revenue After Refund & Tax({unit})',
  'pc_console_revenue_units_net_rev_title': 'Units Revenue After Refund & Tax',
  'pc_console_revenue_dlc_net_rev': 'DLC Revenue After Refund & Tax({unit})',
  'pc_console_revenue_dlc_net_rev_title': 'DLC Revenue After Refund & Tax',
  'pc_console_revenue_unit': 'Units',

  'pc_console_revenue_units_dlc_rev_trends': 'Revenue After Refund & Tax Trends',
  'pc_console_revenue_units_net_rev_trends': 'Units Revenue After Refund & Tax Trends',
  'pc_console_revenue_dlc_net_rev_trends': 'DLC Revenue After Refund & Tax Trends',
  'pc_console_revenue_unit_trends': 'Units Trends',

  'pc_console_revenue_breakdown_category': 'Product Category',
  'pc_console_revenue_breakdown_product': 'Product',
  'pc_console_revenue_breakdown_net_rev_share': 'Share of All (Revenue After Refund & Tax)',
  'pc_console_revenue_breakdown_net_unit_share': 'Share of All (Base Game Units After Refund)',

  'pc_console_revenue_breakdown_total_net_unit_of_category': 'Total Base Game Units After Refund Per Category',
  'pc_console_revenue_breakdown_total_net_revenue_of_category': 'Total Revenue After Refund & Tax Per Category',

  'pc_console_revenue_breakdown_total_net_unit_of_product': 'Total Base Game Units After Refund Per Product',
  'pc_console_revenue_breakdown_total_net_revenue_of_product': 'Total Revenue After Refund & Tax Per Product',

  // Sales Overview
  'pc_console_revenue_sales_overview_tab': 'Sales Overview',
  'pc_console_revenue_sales_breakdown_tab': 'Sales Breakdown',
  'pc_console_revenue_product_analysis_tab': 'Product Analysis',
  'pc_console_revenue_full_game_units': 'Base Game Units After Refund',
  'pc_console_revenue_sum_full_game_units': 'SUM Base Game Units After Refund',
  'pc_console_sales_overview_revenue': 'Revenue After Refund & Tax({unit})',
  'pc_console_sales_overview_revenue_title': 'Revenue After Refund & Tax',
  'pc_console_sales_overview_net_units': 'Base Game Units After Refund',
  'pc_console_sales_overview_net_full_game_revenue': 'Base Game Revenue After Refund & Tax({unit})',

  'pc_console_revenue_sum_full_game_units_revenue': 'SUM Base Game Units After Refund',
  'pc_console_sales_overview_sum_net_revenue': 'SUM Revenue After Refund & Tax({unit})',
  'pc_console_revenue_sum_net_units': 'SUM Base Game Units After Refund',
  'pc_console_revenue_sum_net_full_game_revenue': 'SUM Base Game Revenue After Refund & Tax({unit})',
  'pc_console_revenue_sum_gross_units': 'SUM Gross Units',
  'pc_console_revenue_sum_gross_full_game_units': 'Sum Gross Base Game Units',
  'pc_console_revenue_sum_refunded_units': 'SUM Refunded Units',
  'pc_console_revenue_sum_gross_revenue': 'Sum Gross Revenue({unit})',
  'pc_console_revenue_sum_refund_revenue': 'SUM Refund Revenue({unit})',
  'pc_console_revenue_top_10_revenue': 'TOP 10 Products Revenue After Refund & Tax',
  'pc_console_revenue_top_10_category_revenue': 'TOP 10 Product Category Revenue After Refund & Tax',
  'pc_console_revenue_products': 'Product',
  'pc_console_revenue_categories': 'Product Category',
  'pc_console_revenue_top_10_product_unit': 'TOP 10 Products Base Game Units After Refund',
  'pc_console_revenue_top_10_product_revenue': 'TOP 10 Products Revenue After Refund & Tax',
  'pc_console_revenue_top_10_category_unit': 'TOP 10 Product Category Base Game Units After Refund',
  'pc_console_revenue_numbers': 'Base Game Units After Refund',
  'pc_console_sum': 'SUM',
  'pc_console_avg': 'AVG',
  'pc_console_revenue_top_10_product': 'TOP 10 Products',
  'pc_console_revenue_top_10_category': 'TOP 10 Product Category',

  // 指标卡片
  'pc_console_sales_overview_net_units_sold': 'Base Game Units After Refund',
  'pc_console_sales_overview_gross_units_sold': 'Gross Units',
  'pc_console_sales_overview_third_party_units': 'Third-party Units',
  'pc_console_sales_overview_gross_revenue': 'Gross Revenue',

  'pc_console_sales_overview_units_number': 'Base Game Units After Refund',
  'pc_console_sales_overview_accumulated_units': 'Lifetime Units',
  'pc_console_sales_overview_net_revenue': 'Revenue After Refund & Tax',
  'pc_console_sales_overview_accumulated_revenue': 'Lifetime Revenue',
  'pc_console_sales_overview_asp': 'Average Selling Price (ASP)',
  'pc_console_sales_overview_refund_rate': 'Lifetime Refund Rate',
  'pc_console_sales_overview_left_time_refund_rate': 'Lifetime Refund Rate',
  'pc_console_sales_overview_refund_revenue': 'Refund Revenue',
  'pc_console_sales_overview_refunded_units': 'Refunded Units',
  'pc_console_sum_third_party_units': 'Sum Third-party Units',
  'pc_console_sum_accumaulated_refund_rate': 'Sum Lifetime Refund Rate',
  'pc_console_sum_avg_selling_price_asp': 'Sum Average Selling Price (ASP)',
};